// Bee Together Images
import beeTogether from "../img/beeTogether.png";

// Atlassian Images
import atlassianRovo from "../img/atlassianRovo.png";
import atlassianJira from "../img/atlassianJira.png";

// Groundfloor Images
import groundfloor from "../img/groundfloor.png";

// eeva AI Images
import eevaAI from "../img/eeva.png";
import eevaAITasks from "../img/eevaTask.png";

// Jetson Images
import jetsonLogo from "../img/jetsonLogo.png";
import jetsonGamified from "../img/jetsonGamified.png";
import jetsonChooseYourBusiness from "../img/jetsonChooseYourBusiness.png";
import jetsonAstro from "../img/jetsonAstro.png";

// Blockchains Images
import blockchainsHero from "../img/blockchainsHero.png";
import blockchainsChargeTower from "../img/blockchainsChargeTower.png";
import blockchainsGadgets from "../img/blockchainsGadgets.png";
import blockchainsPeople from "../img/blockchainsPeople.png";

// KeplerSavings Images
import keplerDashboard from "../img/keplerDashboard.png";
import keplerFinalAmount from "../img/keplerFinalAmount.png";
import keplerSpendingHabits from "../img/keplerSpendingHabits.png";
import keplerStartInvesting from "../img/keplerStartInvesting.png";

// GravyStack Images
import gravyStackImg from "../img/gravystack.png";
import gravyStackWhatIs from "../img/gravyStackWhatIs.png";
import gravyStackGuardians from "../img/gravyStackGuardians.png";
import gravyStackHenchmen from "../img/gravyStackHenchmen.png";
import gravyStackTestimonial from "../img/gravyStackTestimonial.png";
import gravyStackMoneyMachine from "../img/gravyStackMoneyMachine.png";
import gravyStackGigs from "../img/gravyStackGigs.png";

// OSRSGuessr Images
import osrsguessrImg from "../img/osrsguessr.png";
import osrsGuessrAboutPage from "../img/osrsGuessrAboutPage.png";
import osrsGuessrHomePage from "../img/osrsGuessrHomePage.png";
import osrsGuessrAuthedHomePage from "../img/osrsGuessrAuthedHomePage.png";
import osrsGuessrSoloRunStatsPage from "../img/osrsGuessrSoloRunStatsPage.png";
import osrsGuessrTellacon from "../img/osrsGuessrTellacon.jpg";
import osrsGuessrJimmy from "../img/osrsGuessrJimmy.jpg";

// Zogo Images
import zogoImg from "../img/zogo.png";
import zogoGamified from "../img/zogoGamified.png";

// High Circle Images
import highCircleImg from "../img/highCircle.png";
import highCircleCarillonParc from "../img/highCircleCarillonParc.png";

// ShipTime Images
import shipTimeImg from "../img/shipTime.png";
import shipTimeBestShipping from "../img/shipTimeBestShipping.png";

// Paid Images
import paidImg from "../img/paid.png";
import paidFlowChart from "../img/paidFlowChart.png";

// Mode Images
import modeImg from "../img/mode.png";
import modeChat from "../img/modeChat.png";

// PokerPower Images
import pokerpowerImg from "../img/pokerpower.png";
import pokerpowerHomeScreen from "../img/pokerpowerHomeScreen.png";
import pokerpowerChatOverlay from "../img/pokerpowerChatOverlay.png";
import pokerpowerDontLeanIn from "../img/pokerpowerDontLeanIn.png";
import pokerpowerTakeYourSeat from "../img/pokerpowerTakeYourSeat.png";
import pokerpowerWinningHand from "../img/pokerpowerWinningHand.png";
import pokerpowerLessonsAreHere from "../img/pokerpowerLessonsAreHere.png";

// Proposterous Images
import proposterousImg from "../img/proposterous.png";
import proposterousHomeScreen from "../img/proposterousHomeScreen.jpg";
import proposterousFirstLevel from "../img/proposterousFirstLevel.png";
import proposterousMicrowave from "../img/proposterousMicrowave.png";
import proposterousFridge from "../img/proposterousFridge.png";
import proposterousOldCode from "../img/proposterousOldCode.jpg";
import proposterousMonitor from "../img/proposterousMonitor.png";
import proposterousCounter from "../img/proposterousCounter.jpg";
import proposterousPreAlphaDevLog1 from "../img/proposterousPreAlphaDevLog1.png";
import proposterousPreAlphaDevLog2 from "../img/proposterousPreAlphaDevLog2.png";

// Lite Squad Images
import liteSquadImg from "../img/litesquad.png";
import litesquadReadyingUp from "../img/litesquadReadyingUp.png";
import litesquadChangingColors from "../img/litesquadChangingColors.png";
import litesquadCustomizing from "../img/litesquadCustomizing.png";
import litesquadPickups from "../img/litesquadPickups.jpg";
import litesquadPrototyping from "../img/litesquadPrototyping.png";
import litesquadCharacterConceptArt from "../img/litesquadCharacterConceptArt.png";
import litesquadZombie from "../img/litesquadZombie.jpg";

// Toady I Learned Images
import toadyImg from "../img/toady.png";
import toadyilearnedSpawn from "../img/toadyilearnedSpawn.png";
import toadyilearnedLilyPad from "../img/toadyilearnedLilyPad.png";
import toadyilearnedEnemyFish from "../img/toadyilearnedEnemyFish.png";
import toadyilearnedEndScreen from "../img/toadyilearnedEndScreen.png";
import toadyilearnedFirstPlace from "../img/toadyilearnedFirstPlace.png";

// BitterGaming Images
import bittergamingImg from "../img/bittergaming.jpeg";
import bittergamingIsland from "../img/bittergamingIsland.jpg";
import bittergamingFreshDarkRPServer from "../img/bittergamingFreshDarkRPServer.jpg";
import bittergamingHoboArea from "../img/bittergamingHoboArea.jpg";
import bittergamingScavenge from "../img/bittergamingScavenge.jpg";
import bittergamingTTTServer from "../img/bittergamingTTTServer.jpg";
import bittergamingNewTTTServer from "../img/bittergamingNewTTTServer.jpg";

// Newest first. Set img to null until a cover image exists; the card shows an empty panel.
// `interests` drives the ordering picked in the tailor modal (game, web, mobile).
// questText, lootText, toolsUsed and contentData show in the detail view; items with none of them have no detail view.
const items = [
  {
    title: "Bee Together",
    tag: "In development",
    interests: ["game"],
    url: null,
    shortDesc:
      "A cozy first-person co-op game where you and your friends build a buzzing little bee farm, care for adorable bees, and grow your homestead into a whimsical honey haven.",
    toolsUsed: [],
    img: beeTogether,
    questText: null,
    lootText: null,
    contentData: [],
  },
  {
    title: "Rovo",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.atlassian.com/software/rovo",
    shortDesc:
      "Atlassian's AI teammate: search, chat and agents that work across a company's knowledge.",
    toolsUsed: [],
    img: atlassianRovo,
    questText: null,
    lootText: null,
    contentData: [],
  },
  {
    title: "Jira",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.atlassian.com/software/jira",
    shortDesc:
      "Project and issue tracking that software teams use to plan, track and ship their work.",
    toolsUsed: [],
    img: atlassianJira,
    questText: null,
    lootText: null,
    contentData: [],
  },
  {
    title: "Groundfloor Inc.",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.groundfloor.com",
    shortDesc:
      "Real estate investing platform that opens private lending to everyday investors.",
    toolsUsed: [],
    img: groundfloor,
    questText: null,
    lootText: null,
    contentData: [],
  },
  {
    title: "Mode",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.mode.io",
    shortDesc: "Out-of-band crisis collaboration platform",
    toolsUsed: [
      "React",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Git",
      "REST API",
      "Jest",
      "Express",
    ],
    img: modeImg,
    questText:
      "Mode is an out-of-band communication and crisis collaboration platform, enabling secure, fast, and controlled response during critical situations. Stay ready with out-of-band collaboration while maintaining control, security, and speed in your response. Stay compliant with incident response frameworks like NIST, CIS, ENISA, and more.",
    lootText:
      "Working on Mode taught me how to build secure communication platforms for critical situations. I learned to implement out-of-band communication systems, ensure compliance with incident response frameworks, and create tools that enable organizations to maintain control and security during crisis situations while facilitating fast and coordinated responses.",
    contentData: [
      {
        img: modeChat,
        isVideo: false,
        videoUrl: null,
        title: "Crisis Communication Interface",
      },
    ],
  },
  {
    title: "Paid",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.paid.com",
    shortDesc: "All-in-one website and payment processing platform",
    toolsUsed: [
      "React",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Git",
      "REST API",
      "Jest",
      "Express",
    ],
    img: paidImg,
    questText:
      "Paid is an all-in-one solution for businesses to launch websites and online stores with seamless online and in-person payment processing. Build your site in seconds with over 50+ templates, accept payments online and in person, send shipments cross country and internationally, all from one unified platform that eliminates the need for plugins and separate solutions.",
    lootText:
      "Working on Paid taught me how to build comprehensive e-commerce platforms that integrate website building, payment processing, and shipping logistics. I learned to create drag-and-drop interfaces, integrate with multiple payment processors, and design unified platforms that simplify complex business operations for entrepreneurs and small businesses.",
    contentData: [
      {
        img: paidFlowChart,
        isVideo: false,
        videoUrl: null,
        title: "Platform Flow Chart",
      },
    ],
  },
  {
    title: "ShipTime",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.shiptime.com",
    shortDesc: "Unified shipping solution for business logistics",
    toolsUsed: [
      "React",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Git",
      "REST API",
      "Jest",
      "Express",
    ],
    img: shipTimeImg,
    questText:
      "ShipTime is a unified shipping solution for businesses to get rates, print labels, track shipments, and manage domestic and global deliveries. With ShipTime's intuitive tools, you can ship envelopes to pallets at up to 70% off top courier rates, get free tracking with real-time updates, and ship to 220+ countries and territories worldwide.",
    lootText:
      "Working on ShipTime taught me how to build comprehensive logistics platforms that integrate with multiple courier services. I learned to handle complex shipping calculations, real-time tracking systems, and create unified dashboards that simplify complex shipping workflows for businesses of all sizes.",
    contentData: [
      {
        img: shipTimeBestShipping,
        isVideo: false,
        videoUrl: null,
        title: "Best Shipping Rates",
      },
    ],
  },
  {
    title: "High Circle Ventures",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.highcircleventures.com",
    shortDesc: "Platform for alternative asset investment management",
    toolsUsed: [
      "React",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Git",
      "REST API",
      "Jest",
      "Carta",
    ],
    img: highCircleImg,
    questText:
      "High Circle Ventures is a platform for investors to access alternative assets like venture capital and real estate, manage investments easily, and track portfolios in one place. We leverage a vast network of industry connections to provide access to high-profile unicorns and niche industry-shakers, while enabling diversification across large real estate projects across the US.",
    lootText:
      "Working on High Circle Ventures taught me how to build sophisticated investment platforms that handle complex financial workflows. I learned to integrate with Carta for fund management, create secure document storage systems, and design user experiences that make alternative investing accessible to a broader range of investors.",
    contentData: [
      {
        img: highCircleCarillonParc,
        isVideo: false,
        videoUrl: null,
        title: "Carillon Parc",
      },
    ],
  },
  {
    title: "eeva AI",
    tag: "Software engineering",
    interests: ["mobile", "web"],
    url: "www.eeva.ai",
    shortDesc: "AI-powered digital assistant for home management",
    toolsUsed: [
      "C#",
      ".NET",
      "React Native",
      "TypeScript",
      "AWS",
      "PostgreSQL",
      "Git",
      "REST API",
      "Jest",
      "Docker",
      "Redis",
      "Node.js",
    ],
    img: eevaAI,
    questText:
      "eeva AI is an AI-powered digital assistant for managing home and personal life, centralizing tasks, documents, schedules, and collaborative household activities.",
    lootText:
      "Working on eeva AI taught me how to design AI systems that understand the complexities of household management. I learned to build intelligent assistants that can seamlessly integrate into daily life and help families stay organized and connected.",
    contentData: [
      {
        img: eevaAITasks,
        isVideo: false,
        videoUrl: null,
        title: "Tasks",
      },
    ],
  },
  {
    title: "Jetson",
    tag: "Software engineering",
    interests: ["mobile"],
    shortDesc: "A Gamified, AI-Powered Entrepreneurship Platform",
    toolsUsed: [
      "React Native",
      "TypeScript",
      "Node.js",
      "MongoDB",
      "AWS",
      "Python",
      "Git",
      "REST API",
      "Jest",
      "Docker",
      "Redis",
      "Express",
    ],
    img: jetsonLogo,
    questText:
      "Jetson is a gamified entrepreneurship platform that uses AI to help users start and grow their businesses.",
    lootText:
      "I've always been interested in working with AI tooling outside of my personal projects. This was a great opportunity to learn more about AI and how it can be used to empower the next generation of entrepreneurs.",
    contentData: [
      {
        img: jetsonGamified,
        isVideo: false,
        videoUrl: null,
        title: "Gamified Learning",
      },
      {
        img: jetsonAstro,
        isVideo: false,
        videoUrl: null,
        title: "Astro",
      },
      {
        img: jetsonChooseYourBusiness,
        isVideo: false,
        videoUrl: null,
        title: "Choose Your Business",
      },
    ],
  },
  {
    title: "Blockchains",
    tag: "Software engineering",
    interests: ["web"],
    url: "www.blockchains.com",
    shortDesc:
      "Privacy-first AI, identity and trust, built for the agentic era.",
    toolsUsed: [
      "NextJS",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Git",
      "REST API",
      "Jest",
      "Express",
    ],
    img: blockchainsHero,
    questText:
      "Blockchains builds privacy-first AI, identity and trust tools for the agentic era: ways for people to prove who they are and control what they share, as more of what happens online is done by software acting on their behalf.",
    lootText:
      "Working on identity and trust systems taught me how much verification changes what people are willing to do online. I learned to build products where privacy is the default, and where proving something about yourself doesn't mean handing over your data.",
    contentData: [
      {
        img: blockchainsGadgets,
        isVideo: false,
        videoUrl: null,
        title: "Gadgets",
      },
      {
        img: blockchainsChargeTower,
        isVideo: false,
        videoUrl: null,
        title: "Charge Tower",
      },
      {
        img: blockchainsPeople,
        isVideo: false,
        videoUrl: null,
        title: "People",
      },
    ],
  },
  {
    title: "KeplerSavings",
    tag: "Founding engineer",
    interests: ["web"],
    shortDesc: "The retirement savings account that stays with you.",
    toolsUsed: [
      "React",
      "TypeScript",
      "Node.js",
      "Python",
      "AWS",
      "PostgreSQL",
      "Redis",
      "Docker",
      "Git",
      "REST API",
      "WebSocket",
      "Jest",
    ],
    img: keplerDashboard,
    questText:
      "KeplerSavings is a retirement savings SaaS that is designed to be a long-term retirement solution for the user. I was the founding engineer and was responsible for the entire tech stack. I was also responsible for the design and implementation of the entire front-end and back-end.",
    lootText:
      "Having worked in FinTech in the past, I was able to leverage that experience to build a highly scalable, highly available SaaS product.",
    contentData: [
      {
        img: keplerFinalAmount,
        isVideo: false,
        videoUrl: null,
        title: "Final Retirement Amount",
      },
      {
        img: keplerSpendingHabits,
        isVideo: false,
        videoUrl: null,
        title: "Spending Habits",
      },
      {
        img: keplerStartInvesting,
        isVideo: false,
        videoUrl: null,
        title: "Start Investing",
      },
    ],
  },
  {
    title: "DinnerTable",
    tag: "Software engineering",
    interests: ["game", "mobile"],
    url: "www.dinnertable.com",
    shortDesc: "A Banking App for Kids That Plays Like a Game.",
    toolsUsed: [
      "Unity",
      "C#",
      "TypeScript",
      "Node.js",
      "NestJS",
      "Plaid",
      "AWS",
      "Git",
      "Docker",
      "MongoDB",
      "Redis",
      "Jest",
    ],
    img: gravyStackImg,
    questText:
      "DinnerTable is a gamified mobile banking app for both kids and parents. I was hired as the first and only full-stack engineer tasked to bridge the gap in communication and tech between the frontend and backend teams.",
    lootText:
      "Converting the way developers think and share ideas across a wide range of skillsets and tools was a gratifying challenge. It was in this role that for the first time I got to see Unity's limitations and bottlenecks first hand. I learned a ton about non-traditional integration strategies by helping create and establish a design pattern to accommodate a C# frontend working with a TypeScript backend.",
    contentData: [
      {
        img: gravyStackMoneyMachine,
        isVideo: false,
        videoUrl: null,
        title: "Money Machine",
      },
      {
        img: gravyStackGigs,
        isVideo: false,
        videoUrl: null,
        title: "Gigs",
      },
      {
        img: gravyStackGuardians,
        isVideo: false,
        videoUrl: null,
        title: "The Guardians",
      },
      {
        img: gravyStackHenchmen,
        isVideo: false,
        videoUrl: null,
        title: "The Henchmen",
      },
      {
        img: gravyStackWhatIs,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/om1OnrZIni8",
        title: "What is GravyStack?",
      },
      {
        img: gravyStackTestimonial,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/BFOpHo-k-1o",
        title: "GravyStack Parent Testimonial Kasaleks Family",
      },
    ],
  },
  {
    title: "OSRSGuessr",
    tag: "Personal project",
    interests: ["game", "web"],
    shortDesc: "A Runescape Map Knowledge Game.",
    toolsUsed: [
      "TypeScript",
      "React",
      "Node",
      "Express",
      "MongoDB",
      "Mongoose",
      "Python",
      "Styled",
      "REST API",
      "Git",
      "Heroku",
      "AWS S3",
      "React-Leaflet",
    ],
    img: osrsguessrImg,
    questText:
      "This game exists purely because I've wanted to play something like it since I was a kid. I always felt more immersed in game worlds than anything else and wanted to challenge my knowledge of Runescape. For most of my personal projects, I prefer Unity -- but with this tech stack OSRSGuessr is accessible to anyone, for free, right in the browser.",
    lootText:
      "At the time of writing this, over 150,000 games have been complete and almost 70,000 accounts have been registered. I was only anticipating around 100 accounts to be created. With this amount of unexpected traffic, OSRSGuessr required hot fixes, optimizations and upgrades around the clock for the first 48 hours. As a result, I feel much more confident with Disaster Recovery and providing real-time support.",
    contentData: [
      {
        img: osrsGuessrSoloRunStatsPage,
        isVideo: false,
        videoUrl: null,
        title: "Tracking Player Stats",
      },
      {
        img: osrsGuessrAuthedHomePage,
        isVideo: false,
        videoUrl: null,
        title: "Simple and Clear Design",
      },
      {
        img: osrsGuessrHomePage,
        isVideo: false,
        videoUrl: null,
        title: "Analytics && Stats on Home Page",
      },
      {
        img: osrsGuessrAboutPage,
        isVideo: false,
        videoUrl: null,
        title: "Community-Driven Design and Mission",
      },
      {
        img: osrsGuessrJimmy,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/AjITXHdTHYc",
        title: "Jimmy's Raw Reaction to OSRSGuessr",
      },
      {
        img: osrsGuessrTellacon,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/ISiAqU9lS4E",
        title: "Tellacon's Raw Reaction to OSRSGuessr",
      },
    ],
  },
  {
    title: "Zogo",
    tag: "Software engineering",
    interests: ["mobile", "game"],
    url: "www.zogo.com",
    shortDesc: "Gamified financial literacy education platform",
    toolsUsed: [
      "Ionic",
      "Angular",
      "React Native",
      "TypeScript",
      "Node.js",
      "REST API",
      "SQL",
      "AWS",
      "Git",
      "Docker",
      "Jest",
      "MongoDB",
      "Redis",
    ],
    img: zogoImg,
    questText:
      "Zogo is a gamified mobile app and platform that provides bite-sized financial literacy education to users, primarily through partnerships with financial institutions like banks and credit unions. Users earn virtual 'Pineapples' for completing modules, taking quizzes, and participating in trivia, which can then be redeemed for real-world rewards like gift cards to popular retailers.",
    lootText:
      "Working on Zogo taught me how to create engaging educational experiences through gamification. I learned to build scalable mobile apps that can serve over 1.5 million users while maintaining performance and user engagement. The project gave me insight into fintech partnerships and how to make complex financial topics accessible to younger demographics.",
    contentData: [
      {
        img: zogoGamified,
        isVideo: false,
        videoUrl: null,
        title: "Zogo Mobile",
      },
    ],
  },
  {
    title: "Poker Power",
    tag: "Software engineering",
    interests: ["mobile", "game"],
    url: "www.pokerpower.com",
    shortDesc: "The Online Poker App That Empowers Women.",
    toolsUsed: [
      "React Native",
      "TypeScript",
      "Python",
      "Node.js",
      "NestJS",
      "GraphQL",
      "Redis",
      "MongoDB",
      "AWS",
      "Git",
      "Docker",
      "Jest",
    ],
    img: pokerpowerImg,
    questText:
      "I was hired to help bring the awesome vision of PokerPower to life. The primary motivation behind PokerPower is to teach women how to learn and utilize life skills through poker. Learning when to double down, how to bluff and knowing when you have the upper-hand are just a few ideals of many shared by the PokerPower team, teachers and students alike.",
    lootText:
      "On a personal level, I strongly stand by the philosophy that PokerPower is cultivating. On a more technical level, I've learned so much more about proper networking etiquette, optimizing queries and leveraging faster technologies for delivering high-priority on-demand data right when users need it.",
    contentData: [
      {
        img: pokerpowerDontLeanIn,
        isVideo: false,
        videoUrl: null,
        title: "Go All In.",
      },
      {
        img: pokerpowerWinningHand,
        isVideo: false,
        videoUrl: null,
        title: "We Have A Winner!",
      },
      {
        img: pokerpowerLessonsAreHere,
        isVideo: false,
        videoUrl: null,
        title: "Lessons Are Here.",
      },
      {
        img: pokerpowerTakeYourSeat,
        isVideo: false,
        videoUrl: null,
        title: "Take Your Seat.",
      },
      {
        img: pokerpowerHomeScreen,
        isVideo: false,
        videoUrl: "https://www.youtube.com/embed/AjITXHdTHYc",
        title: "Home Screen",
      },
      {
        img: pokerpowerChatOverlay,
        isVideo: false,
        videoUrl: "https://www.youtube.com/embed/ISiAqU9lS4E",
        title: "Chat With Your Friends!",
      },
    ],
  },
  {
    title: "Proposterous",
    tag: "Game",
    interests: ["game"],
    url: null,
    shortDesc: "A Prop-Hunt meets Ghostbusters party game.",
    toolsUsed: [
      "Unity",
      "C#",
      "JavaScript",
      "MongoDB",
      "Blender",
      "Substance Painter",
      "Git",
      "Photon",
      "UNet",
      "URP",
      "Photoshop",
      "Gimp",
    ],
    img: proposterousImg,
    questText:
      "A game where you either play as ghosts or ghost hunters. As a ghost, you possess props and try to evade hunters. As hunters, your job is to exterminate all paranormal activity. I started this project to learn more about peer-to-peer networking with fully synchronized and accurate physics events; And it's just a fantastic and fresh spin-off of the old classic 'Prop-Hunt' game. Before I put the project on hold, I had up to 8 players in a single game with a full gameplay loop completed.",
    lootText:
      "When I was still working on Proposterous, I was learning new ways to 'min-max' network optimization and user experience(UX). I found really creative ways to always make the player 'feel' like their inputs are being processed in real-time as if they were in a single-player game.",
    contentData: [
      {
        img: proposterousFirstLevel,
        isVideo: false,
        videoUrl: null,
        title: "Beginnings of First Map",
      },
      {
        img: proposterousHomeScreen,
        isVideo: false,
        videoUrl: null,
        title: "Very Place-holder Home Screen",
      },
      {
        img: proposterousMicrowave,
        isVideo: false,
        videoUrl: null,
        title: "Social Media Microwave",
      },
      {
        img: proposterousFridge,
        isVideo: false,
        videoUrl: null,
        title: "Social Media Fridge",
      },
      {
        img: proposterousOldCode,
        isVideo: false,
        videoUrl: null,
        title: "Some old dusty code from handling lobby events",
      },
      {
        img: proposterousMonitor,
        isVideo: false,
        videoUrl: null,
        title: "'Game of the year 2021' - Our Artist",
      },
      {
        img: proposterousCounter,
        isVideo: false,
        videoUrl: null,
        title: "The Counter Created for the Break Room",
      },
      {
        img: proposterousPreAlphaDevLog1,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/RVG4CAxlAwQ",
        title: "Very Early Development Video",
      },
      {
        img: proposterousPreAlphaDevLog2,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/9tAqBNHW_qY",
        title: "Custom Physics Camera Collisions",
      },
    ],
  },
  {
    title: "Lite Squad",
    tag: "Game",
    interests: ["game"],
    url: null,
    shortDesc: "A Thematic Online Top-Down Monster Shooter.",
    toolsUsed: [
      "Unity",
      "C#",
      "JavaScript",
      "Blender",
      "Git",
      "Photon",
      "UNet",
      "URP",
      "Gimp",
    ],
    img: liteSquadImg,
    questText:
      "A very thematic Online Multiplayer Top-Down Shooter when you team-up and play as kid's miniaturized night-lights to fight off nightmarish monsters throughout the night. Up to 4-players can play and complete levels by controlling and defending sleeping kids in their life-sized bedroom. I tinkered with this idea because I wanted to understand the challenges of creating a multiplayer experience with 'homemade' AI.",
    lootText:
      "This project is where I solidified my understanding of creating compelling AI, synchronizing clients, physics and user experience(UX) best practices. Another big win was learning how to optimize 3D and 2D assets for performance as there are potentially over hundred assets on-screen at a time.",
    contentData: [
      {
        img: litesquadCharacterConceptArt,
        isVideo: false,
        videoUrl: null,
        title: "Character Concept Art",
      },
      {
        img: litesquadZombie,
        isVideo: false,
        videoUrl: null,
        title: "Zombie Concept Model",
      },
      {
        img: litesquadPickups,
        isVideo: false,
        videoUrl: null,
        title: "Alpha Weapon Pickups w/ Rarity",
      },
      {
        img: litesquadChangingColors,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/AB0_Q70VKpE",
        title: "Changing Teams(Colors)",
      },
      {
        img: litesquadReadyingUp,
        isVideo: true,
        videoUrl: "https://www.youtube.com/embed/R5zKn81Zov0",
        title: "Players Joining and Readying Up",
      },
      {
        img: litesquadCustomizing,
        isVideo: true,
        videoUrl:
          "https://i.gyazo.com/c6fd1cce851522c0bf6ff846e6170523.mp4",
        title: "Early Player Customization",
      },
      {
        img: litesquadPrototyping,
        isVideo: true,
        videoUrl:
          "https://i.gyazo.com/901820801382fd0e0707134777023aa5.mp4",
        title: "Enter Prototyping Phase",
      },
    ],
  },
  {
    title: "Toady I Learned",
    tag: "Game jam",
    interests: ["game"],
    url: "fcolor04.itch.io/toady-i-learned",
    shortDesc: "Made in 48 Hours. Theme: Starting Small.",
    toolsUsed: [
      "Unity",
      "Unity Collab",
      "C#",
      "JavaScript",
      "Git",
      "Photoshop",
      "Gimp",
    ],
    img: toadyImg,
    questText:
      "I wanted to put my team-building, project-blueprinting and time-management skill to the test. So, I made a game in 48 hours with a person I had never met before who was in a different timezone than me. After 48 hours this game was auto-submitted into a game-jam contest.",
    lootText:
      "We won 1st place in the contest with the highest ratings! We managed to squeeze in AI, music, SFX and an end-screen. I learned much more than I had anticipated and I plan on doing these short-term projects again in the future. It offers 5-10 minutes of playtime.",
    contentData: [
      {
        img: toadyilearnedSpawn,
        isVideo: false,
        videoUrl: null,
        title: "Initial Spawn",
      },
      {
        img: toadyilearnedLilyPad,
        isVideo: false,
        videoUrl: null,
        title: "Perspective Elements",
      },
      {
        img: toadyilearnedEnemyFish,
        isVideo: false,
        videoUrl: null,
        title: "Enemy Fish AI",
      },
      {
        img: toadyilearnedEndScreen,
        isVideo: false,
        videoUrl: null,
        title: "End Game Screen",
      },
      {
        img: toadyilearnedFirstPlace,
        isVideo: false,
        videoUrl: null,
        title: "We Placed 1st!",
      },
    ],
  },
  {
    title: "BitterGaming",
    tag: "Game servers",
    interests: ["game"],
    url: null,
    shortDesc: "Top-Ranked GMod and Minecraft Servers.",
    toolsUsed: [
      "Lua",
      "FTP(FileZilla)",
      "MySQL",
      "Php",
      "HTML",
      "CSS",
      "Java",
      "JavaScript",
      "C++",
      "Blender",
      "Gimp",
      "LMMS",
      "Paypal Integ.",
    ],
    img: bittergamingImg,
    questText:
      "As a highschool student I created many successful Garrysmod and Minecraft servers. I maintained and added content to these servers on set development cycles. I also hand-picked an administrative team to help moderate and manage operations during my downtime. I implemented holiday events, user-specific events (such as birthdays), and custom-built a system that awarded players for their time spent on our network of servers.",
    lootText:
      "Luckily, I got to learn all of the hard lessons of software engineering early with these servers. Disaster struck many times, and my disaster recovery skills and general confidence were bolstered by this. My servers consistently ranked in top 1-5% of the top-ranked servers in the world because of my community-driven approach to server management.",
    contentData: [
      {
        img: bittergamingIsland,
        isVideo: false,
        videoUrl: null,
        title: "Custom Island",
      },
      {
        img: bittergamingHoboArea,
        isVideo: false,
        videoUrl: null,
        title: "Community Created Hobo Area",
      },
      {
        img: bittergamingFreshDarkRPServer,
        isVideo: false,
        videoUrl: null,
        title: "A Fresh DarkRP Server",
      },
      {
        img: bittergamingNewTTTServer,
        isVideo: false,
        videoUrl: null,
        title: "New TTT Server",
      },
      {
        img: bittergamingScavenge,
        isVideo: false,
        videoUrl: null,
        title: "I Made 'Scavenge', A Custom Gamemode",
      },
      {
        img: bittergamingTTTServer,
        isVideo: false,
        videoUrl: null,
        title: "Old TTT Server",
      },
    ],
  },
];

const softwareTags = ["Software engineering", "Founding engineer"];

// Codes are numbered in list order within each group: SW for product work, EXP for games and experiments.
let softwareCount = 0;
let experimentCount = 0;

const work = items.map((item) => {
  const isSoftware = softwareTags.includes(item.tag);
  const count = isSoftware ? ++softwareCount : ++experimentCount;
  return {
    ...item,
    isSoftware,
    code: `${isSoftware ? "SW" : "EXP"}–${String(count).padStart(3, "0")}`,
  };
});

export default work;
